import { createFileRoute } from "@tanstack/react-router"
import { AixContentBody } from "@aix/ui"
import { BreadcrumbBanner } from "~/components/BreadcrumbBanner"
import { VideoList } from "~/components/VidMax/VideoList"
import AppLayout from "~/layouts/AppLayout"
import { useAtomValue } from "jotai"
import { navStyleAtom } from "~/context/jotai"

function VideosPage() {
  const breadcrumbItems = [{ label: "Home", href: "/home" }, { label: "My Videos" }]
  const navStyle = useAtomValue(navStyleAtom)

  return (
    <AppLayout>
      {navStyle !== "twoTier" && <BreadcrumbBanner items={breadcrumbItems} />}

      <AixContentBody>
        <VideoList />
      </AixContentBody>
    </AppLayout>
  )
}

export const Route = createFileRoute("/videos/")({
  component: VideosPage,
})
